import React, { useEffect, useState } from 'react'
import Layout from '../../components/layout/layout'
import AddDevice from '../../components/device/device-mangament/create-device/device-modal.component'
import styles from './device-management.module.css'
import ConfigureDevice from '../../components/configuration-templates/configuration-modal-component'
import DeviceView, {
  DeviceViewContext,
} from '../../components/device/device-info-view/deviceView'
import SpeedDials from '../../components/device/device-actions/index'
import { DEVICE_STATUS_ENUM } from '../../services/device'
import ProvisionConfirmDialog from '../../components/assets/asset-provision/confirm-dialog'
import DeviceBulkUpload from '../../components/bulk-upload/bulkUpload.componant'
import DeviceList from '../../components/device/device-list/deviceList.component'

export default function DeviceManagement() {
  const [viewDevice, setViewDevice] = useState(false)
  const [deviceData, setDeviceData] = useState(false)
  const [show, setShow] = useState(false)
  const [openTemplateDialog, setOpenTemplateDialog] = useState(false)
  const [showConfirmDialog, setShowConfirmDialog] = useState(false)
  const [showDeviceBulk, setDeviceBulkShow] = useState(false)

  useEffect(() => {
    setViewDevice(false)
  }, [])

  return (
    <Layout>
      <DeviceViewContext.Provider
        value={{
          viewDevice,
          setViewDevice,
          deviceData,
          setDeviceData,
          openTemplateDialog,
          showDeviceBulk,
          setDeviceBulkShow,
          setOpenTemplateDialog,
          showConfirmDialog,
          setShowConfirmDialog,
        }}
      >
        <div className={styles.container}>
          {viewDevice ? (
            <DeviceView />
          ) : (
            <>
              <DeviceList
                className={styles.list}
                status={DEVICE_STATUS_ENUM.ALL}
              />
              <SpeedDials
                show={show}
                setShow={setShow}
                showDeviceBulk={showDeviceBulk}
                setDeviceBulkShow={setDeviceBulkShow}
              />
              <AddDevice
                show={show}
                setShow={setShow}
                className={styles.actions}
              />
              <ConfigureDevice />
              <ProvisionConfirmDialog
                showConfirmDialog={showConfirmDialog}
                setShowConfirmDialog={setShowConfirmDialog}
                device={deviceData}
              />
              <DeviceBulkUpload
                showDeviceBulk={showDeviceBulk}
                setDeviceBulkShow={setDeviceBulkShow}
              />
            </>
          )}
        </div>
      </DeviceViewContext.Provider>
    </Layout>
  )
}
